import { useState, useCallback } from 'react';
import { getFullData } from '../utils/api';

export default function useStock() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentSymbol, setCurrentSymbol] = useState(null);

  const load = useCallback(async (symbol) => {
    setLoading(true);
    setError(null);
    setCurrentSymbol(symbol);
    try {
      const result = await getFullData(symbol);
      setData(result);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData(null);
    setError(null);
    setCurrentSymbol(null);
    setLoading(false);
  }, []);

  return { data, loading, error, currentSymbol, load, reset };
}
